"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.signAndSendEnhancedTxns = void 0;
const constants_1 = require("../constants");
const anchor_1 = require("@project-serum/anchor");
const lodash_1 = require("lodash");
const STANDART_LOOKUP_TABLE = new anchor_1.web3.PublicKey(constants_1.LOOKUP_TABLE);
//? Sequence means that transactions will be signed at once, but will be sent in a sequence by chunks.
//? F.e. txnsAndSigners: [[x, x, x], [y, y, y], [z, z, z]]. Sign all txns at once. But first send [x, x, x], wait for confirmation, send [y, y, y] wait for confirmation, send [z, z, z]
//? It needs when transactions from next chunk are related to transactions from previos chunk
const signAndSendEnhancedTxns = ({ fastTrackInstructionsAndSigners, connection, wallet, split, skipPreflight, commitment = 'confirmed', onBeforeApprove, onAfterSend, onSuccess, onError, }) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        if (split) {
            const txnsInChunk = split;
            for (const txnsAndSigners of (0, lodash_1.chunk)(fastTrackInstructionsAndSigners, txnsInChunk)) {
                yield (0, exports.signAndSendEnhancedTxns)({
                    fastTrackInstructionsAndSigners: [...txnsAndSigners],
                    connection,
                    wallet,
                    commitment,
                    onAfterSend,
                    onSuccess,
                    onError,
                });
            }
            return true;
        }
        const { blockhash: blockhashFirst } = yield connection.getLatestBlockhash();
        const fastTrackV0Transactions = yield Promise.all(fastTrackInstructionsAndSigners.map((ixAndSigner) => __awaiter(void 0, void 0, void 0, function* () {
            console.log('STANDART_LOOKUP_TABLE: ', STANDART_LOOKUP_TABLE.toBase58());
            const lookupTable = (yield connection.getAddressLookupTable(STANDART_LOOKUP_TABLE))
                .value;
            const transactionsMessageV0 = new anchor_1.web3.VersionedTransaction(new anchor_1.web3.TransactionMessage({
                payerKey: wallet.publicKey,
                recentBlockhash: blockhashFirst,
                instructions: ixAndSigner.instructions,
            }).compileToV0Message([lookupTable]));
            transactionsMessageV0.sign([...(ixAndSigner.signers || [])]);
            return transactionsMessageV0;
        })));
        onBeforeApprove === null || onBeforeApprove === void 0 ? void 0 : onBeforeApprove();
        const transactionsFlatArrLookupTables = [...fastTrackV0Transactions];
        const signedTransactionsLookupTables = yield wallet.signAllTransactions([...transactionsFlatArrLookupTables]);
        // const txnsAndSignersWithV0Txns = [
        //   ...txnsAndSigners,
        //   // v0MainAndCloseTableTxns,
        // ];
        const txnsAndSignersWithFastTrack = [fastTrackV0Transactions];
        let currentTxIndexLookupTable = 0;
        for (let i = 0; i < txnsAndSignersWithFastTrack.length; i++) {
            for (let r = 0; r < txnsAndSignersWithFastTrack[i].length; r++) {
                if (txnsAndSignersWithFastTrack[i].length === 0)
                    continue;
                console.log('currentTxIndexLookupTable: ', currentTxIndexLookupTable);
                const txn = signedTransactionsLookupTables[currentTxIndexLookupTable];
                // lastSlot = await connection.getSlot();
                const tx = yield connection.sendRawTransaction(txn.serialize(), {
                    skipPreflight: !!skipPreflight,
                    preflightCommitment: 'processed',
                });
                currentTxIndexLookupTable += 1;
                // console.log("MinContextSlot: ", txn.minNonceContextSlot)
            }
        }
        onAfterSend === null || onAfterSend === void 0 ? void 0 : onAfterSend();
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        return true;
    }
    catch (error) {
        onError === null || onError === void 0 ? void 0 : onError(error);
        return false;
    }
});
exports.signAndSendEnhancedTxns = signAndSendEnhancedTxns;
